// ============================================================
// caseSnapshotGuard — protects CASE-level collab note snapshots.
//
// Case sections persist a collab editor's HTML snapshot through
// updateCase(...), which writes to whatever case is CURRENTLY open in the
// store. RichTextEditor now FLUSHES a pending snapshot when the editor unmounts
// (so a note typed just before navigating away isn't lost). If that unmount is
// a switch to ANOTHER case, the flush would otherwise land the old case's HTML
// in the new case. This wrapper drops the write unless the snapshot's case is
// still the open one. (Row-keyed notes — deadlines, witnesses, tasks, client
// notes — carry their own id and don't need this.)
// ============================================================
import { useCasevoStore } from '../store/useCasevoStore'

export const forOpenCase = (caseId: string, fn: (html: string) => void) =>
  (html: string): void => {
    if (useCasevoStore.getState().currentCase?.id !== caseId) return
    fn(html)
  }
